// pages/ClientMenuSwitches.jsx
// Admin → Production Launch Controls → "Uganda client menu": turn Buy USDT,
// Withdraw Crypto, Analytics, Referral and ISP & Network on or off for Uganda
// client accounts. OFF hides the menu item and blocks its server routes; money
// can always leave (USDT / commission holders keep their way out). Wallet is
// never switched. Admins, merchants, agents, partners and DRC clients are not affected.
import { useState, useEffect, useCallback } from 'react';
import toast from 'react-hot-toast';
import { clientModuleAPI } from '../services/api';
import { Card, Badge, Button, Spinner } from '../components/ui';

export default function ClientMenuSwitches() {
  const [rows, setRows] = useState(null);
  const [busy, setBusy] = useState('');
  const load = useCallback(() => clientModuleAPI.adminList().then(r => setRows(r.modules || [])).catch(err => toast.error(err.message)), []);
  useEffect(() => { load(); }, [load]);

  const flip = async m => {
    const on = !m.enabled;
    const msg = on ? `Show "${m.label}" to Uganda clients again?`
      : `Hide "${m.label}" from Uganda clients and block it?${m.keepIf ? ` ${m.keptByBalance} ${m.keepIf} keep it so their money can leave.` : ''}`;
    if (!window.confirm(msg)) return;
    setBusy(m.key);
    try { await clientModuleAPI.adminSet(m.key, on); toast.success(`${m.label} ${on ? 'ON' : 'OFF'}`); await load(); }
    catch (err) { toast.error(err.message); }
    finally { setBusy(''); }
  };

  return (
    <Card>
      <h3 className="font-bold text-text-primary">Uganda client menu</h3>
      <p className="text-text-muted text-xs mt-1 mb-3">
        OFF hides the item and blocks it for Uganda client accounts — within about a minute, no restart. Wallet &amp; Payments,
        DwiSend, KYC and Settings always stay. Admins, merchants, agents, partners and DRC clients are not affected.
      </p>
      {rows === null ? <Spinner /> : (
        <div className="space-y-2">
          {rows.map(m => (
            <div key={m.key} className="flex items-center justify-between gap-3 border border-border rounded-lg p-2" data-testid={`client-module-${m.key}`}>
              <div className="min-w-0">
                <div className="text-sm font-semibold text-text-primary">{m.label} <span className="text-xs text-text-muted font-mono">{m.path}</span></div>
                <div className="text-xs text-text-muted">
                  {m.keepIf ? `When OFF, still open to ${m.keepIf} (${m.keptByBalance} now).` : 'When OFF, hidden for all Uganda clients.'}
                  {m.allowedAccounts > 0 ? ` ${m.allowedAccounts} account(s) always allowed.` : ''}
                </div>
              </div>
              <div className="flex items-center gap-2 shrink-0">
                <Badge label={m.enabled ? 'ON' : 'OFF'} color={m.enabled ? 'green' : 'gray'} />
                <Button size="xs" variant={m.enabled ? 'ghost' : 'primary'} loading={busy === m.key} onClick={() => flip(m)}>{m.enabled ? 'Turn off' : 'Turn on'}</Button>
              </div>
            </div>
          ))}
        </div>
      )}
    </Card>
  );
}
